export enum StatusEnum{
    active='Active',
    inActive='InActive',
    deleted='Deleted'
}